import { Close } from "@mui/icons-material";
import ChatIcon from "@mui/icons-material/Chat";
import RestoreIcon from "@mui/icons-material/Restore";
import { Box, IconButton, Tooltip, Typography, CircularProgress } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import moment from "moment";
import { useState } from "react";
import TitleContainer from "../../commons/table/utilsTable/titleWithFetchData";
import { StyledMessaging } from "../../styled/messaging";

const MessagingTable = ({
  data,
  loading,
  searchMode = false,
  onViewMessages,
  onViewAccident,
  onCloseConversation,
  onReopenConversation,
  title,
  fetchData,
}) => {
  const [loadingAccidentId, setLoadingAccidentId] = useState(null);
  const columns = [
    {
      accessorKey: "idConversacionExterna",
      header: "Conversación",
      Cell: ({ row }) => (
        <Typography variant="body2">
          {row.original.idConversacionExterna ? "#" + row.original.idConversacionExterna : "Pendiente Asignación"}
        </Typography>
      ),
    },
    {
      accessorKey: "art",
      header: "ART",
    },
    {
      accessorKey: "trabajador",
      header: "Trabajador",
    },
    {
      accessorKey: "siniestro",
      header: "Siniestro",
    },
    {
      accessorKey: "documento",
      header: "Documento",
    },
    {
      accessorKey: "empleador",
      header: "Empleador",
    },
    {
      accessorKey: "tipoMensaje",
      header: "Tipo",
    },
    {
      accessorKey: "subtipoMensaje",
      header: "Subtipo",
    },
    {
      accessorKey: "titulo",
      header: "Título",
    },
    ...(searchMode
      ? [
        {
          accessorKey: "estado",
          header: "Estado",
        },
      ]
      : []),
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data || []}
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      enableRowActions
      positionActionsColumn="last"
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "Acciones",
          size: 150,
        },
      }}
      renderTopToolbarCustomActions={() => (
        <StyledMessaging.TableToolbarWrapper>
          <TitleContainer
            title={title || "Mensajería"}
            noRefresh={!fetchData}
            fetchData={fetchData}
          />
        </StyledMessaging.TableToolbarWrapper>
      )}
      renderRowActions={({ row }) => (
        <StyledMessaging.TableActionsWrapper>
          <Tooltip title="Ver Mensajes">
            <IconButton
              onClick={() => onViewMessages(row.original)}
            >
              <ChatIcon />
            </IconButton>
          </Tooltip>

          {row.original.siniestro && (
            <Tooltip title="Ver Siniestro">
              <span
                onClick={() => {
                  if (loadingAccidentId) return;
                  setLoadingAccidentId(row.original.idConversacion);
                  const promise = onViewAccident(row.original);
                  if (promise && promise.finally) {
                    promise.finally(() => setLoadingAccidentId(null));
                  } else {
                    setLoadingAccidentId(null);
                  }
                }}
                style={{ display: 'inline-flex', cursor: 'pointer' }}
              >
                {loadingAccidentId === row.original.idConversacion ? (
                  <IconButton size="small" disableRipple sx={{ p: 0, m: 1 }}>
                    <CircularProgress size={20} />
                  </IconButton>
                ) : (
                  <StyledMessaging.ClickableVisibilityIcon />
                )}
              </span>
            </Tooltip>
          )}

          {row.original.puedeCerrar && (
            <Tooltip title="Cerrar">
              <IconButton
                onClick={() => onCloseConversation(row.original)}
              >
                <Close />
              </IconButton>
            </Tooltip>
          )}

          {searchMode && row.original.puedeReabrir && (
            <Tooltip title="Reabrir">
              <IconButton
                onClick={() => onReopenConversation(row.original)}
              >
                <RestoreIcon />
              </IconButton>
            </Tooltip>
          )}
        </StyledMessaging.TableActionsWrapper>
      )}
      renderDetailPanel={({ row }) => {
        const ultimosMensajes = row.original.ultimosMensajes || [];
        if (ultimosMensajes.length === 0) {
          return <Typography>No hay mensajes recientes para mostrar.</Typography>;
        }

        return (
          <StyledMessaging.DetailPanelContainer>
            <Typography variant="subtitle1" fontWeight="bold" mb={1}>Últimos Mensajes:</Typography>
            {ultimosMensajes.map((m) => (
              <StyledMessaging.DetailMessageRow key={m.idMensaje}>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {m.remitente} - {moment(m.fechaHoraEnvio).format("DD/MM/YYYY HH:mm")}
                  </Typography>
                  <Typography variant="body2">{m.mensaje}</Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="textSecondary">{m.estado}</Typography>
                </Box>
              </StyledMessaging.DetailMessageRow>
            ))}
          </StyledMessaging.DetailPanelContainer>
        );
      }}
    />
  );
};

export default MessagingTable;
